module.exports = __webpack_public_path__ + "img/last-md.fa97811.webp";